import React from 'react'
import {CSpinner, CToast, CToastBody, CToastClose} from '@coreui/react'

const Loading = (props) => {

    return (
        <div style={{
          position: 'absolute',
          background: '#00000099',
          zIndex: 999,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh'
        }}>
            <CToast autohide={false} visible={true} className="align-items-center">
                <div className="d-flex">
                    <CToastBody>처리중입니다...</CToastBody>
                </div>
            </CToast>
        </div>
    )
}

export default Loading
